<template>
	<ja-modal v-if="simulation" :show="show" class="modal-delete-simulation">
		<ja-close-button
			class="close-delete-modal"
			name="close"
			@click.native="closeModal"
		></ja-close-button>

		<div class="modal-content">
			<h3>{{ $t('deleteSimulationTitle') }}</h3>
			<div class="btn-wrapper">
				<ja-button
					class="small"
					name="delete-simulation"
					@click.native="deleteSimulation(simulation)"
					>{{ $t('yes') }}</ja-button
				>
				<ja-button
					class="small outlined btn-no"
					name="dont-delete-simulation"
					@click.native="closeModal"
					>{{ $t('cancel') }}</ja-button
				>
			</div>
		</div>
	</ja-modal>
</template>

<script>
import '@/components/icons/arrow-right';
import '@/components/icons/modal-close';
import Button from '../../ui/Button';
import Modal from '../../Modal/Modal';
import gql from 'graphql-tag';
import CloseButton from '../../ui/CloseButton';

export default {
	components: {
		jaButton: Button,
		jaModal: Modal,
		jaCloseButton: CloseButton
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		simulation: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			logoutAttempt: false
		};
	},

	methods: {
		closeModal() {
			this.$emit('closeDeleteSimulationModal');
		},
		async deleteSimulation(simulation) {
			const response = await this.$apollo.mutate({
				mutation: gql`
					mutation($id: Int!) {
						deleteSimulation(id: $id)
					}
				`,
				variables: {
					id: simulation.id
				}
			});
			if (response.data) {
				this.closeModal();
				this.$store.commit('setLoading', true);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.modal-delete-simulation {
	position: fixed;

	.close-delete-modal {
		height: 38px;
		width: 38px;
	}

	.modal-content {
		min-height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;

		h3 {
			text-transform: initial;
		}

		.btn-wrapper {
			margin-top: 8px;
			.btn-no {
				margin-left: 16px;
			}
		}
	}
}
content {
	padding: 48px;
}

.cancel-button,
.confirm-button {
	margin-top: 48px;
}

.cancel-button {
	margin-right: 16px;
}

.close-button {
	position: absolute;
	height: 32px;
	width: 32px;
	border-radius: 100%;
	padding: 8px;
	right: 16px;
	top: 16px;
	outline: 0;
	border: 0;
	background-color: $container-bgcolor;
	@media (any-hover: hover) {
		&:hover {
			cursor: pointer;
			svg {
				fill: $hover-state;
			}
		}
	}

	&:active {
		svg {
			fill: $tapped-state;
		}
	}
	svg {
		fill: $primary-state;
	}
}
</style>
